import { render, staticRenderFns } from "./AvailableServices.vue?vue&type=template&id=930923d6"
import script from "./AvailableServices.vue?vue&type=script&lang=ts"
export * from "./AvailableServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports